import classNames from 'classnames';
import { FieldProps, useFormikContext } from 'formik';
import { ReactElement, useCallback } from 'react';
import UDFormFieldWrapper from '../../wrapper';
import { UDFormComponentProps } from '../types';
import UDSelect, { UDSelectProps } from './component';

type UDFormSelectProps<isMulti extends boolean> = UDFormComponentProps &
  UDSelectProps<isMulti> & {
    selectComponent?: (props: any) => ReactElement<any, any> | null;
  };

type Returning = <isMulti extends boolean = false>(props: UDFormSelectProps<isMulti>) => JSX.Element;

const UDFormSelect: Returning = (props) => {
  const { name, containerProps, required, label, labelProps, selectComponent, ...otherSelectProps } = props;

  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (value: any, isMulti: any) => {
      setFieldValue(name, value);

      if (props.onChange) {
        props.onChange(value, isMulti);
      }
    },
    [name, props, setFieldValue],
  );

  const Component = selectComponent || UDSelect;

  return (
    <UDFormFieldWrapper name={name} containerProps={containerProps} label={label} labelProps={labelProps} required={required}>
      {({ field, meta }: FieldProps<any>) => (
        <Component
          {...otherSelectProps}
          {...field}
          divProps={{
            className: classNames('w-full'),
          }}
          className={classNames('w-full', otherSelectProps?.className)}
          onChange={onChange}
          hasError={Boolean(meta.error)}
        />
      )}
    </UDFormFieldWrapper>
  );
};

export default UDFormSelect;
